import { Duration } from 'luxon'

export const useFormatDuration = (seconds: number) => {
  return Duration.fromMillis(seconds * 1000 || 0).toFormat(
    seconds > 3600 ? "h'h'mm" : "m'min'"
  )
}
